import { createApp } from 'vue'
import { createPinia } from 'pinia'
import naive from 'naive-ui'
import App from './App.vue'
import { router } from './router'
import { installNuxtCompat, ClientOnly, NuxtLink, setAppRouter } from './shims/nuxt-compat'
import './styles/main.css'

installNuxtCompat()

const app = createApp(App)
app.use(createPinia())
app.use(router)
setAppRouter(router)
app.use(naive)
app.component('ClientOnly', ClientOnly)
app.component('NuxtLink', NuxtLink)
app.mount('#app')
